import React, { useState, useEffect } from "react";
import ConfirmPopUp from "./ConfirmPopUp";
import Header from "./Header";
import Loader from "./Loader";
import axios from "axios";
import config, { getHeaders } from "../config";
import Alert from "./Alert";
import { useNavigate } from "react-router-dom";
import { logSubEvent, logEvent } from "../analytics/AnalyticsEvent";
import { events, screen } from "../analytics/eventName";
import {accountPageText as text} from "../database/Text";
import { useMainContext } from "../callContext/MainContext";

const Account = () => {
  const [showModel, setShowModel] = useState(false);
  const {language}=useMainContext();
  const [displayStatus, setDisplayStatus] = useState(localStorage.getItem("displayStatus") || "");
  const [userStatus, setUserStatus] = useState("");
  const [msisdn, setMsisdn] = useState(localStorage.getItem("msisdn")|| "");
  const [validity, setValidity] = useState(localStorage.getItem("validity") || "");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const uid = localStorage.getItem("uid")
    ? localStorage.getItem("uid")
    : "";
  const [subObj, setSubObj] = useState({
    sub_btn_text: "",
    sub_url: "",
  });
  const [unsubObj, setUnsubObj] = useState({
    msg_txt: "",
    unsub_btn_text: "",
    cancel_btn_text: "cancel",
    ok_btn_text: "ok",
    usub_url: "",
  });
  useEffect(() => {
    const unsub_btn_text = JSON.parse(
      localStorage.getItem("unsubscribeBtnText")
    );
    const msg_text = JSON.parse(localStorage.getItem("unsubscribe_alert_msg"));
    const sub_text = JSON.parse(localStorage.getItem("subscribeBtnText"));
    const sub_url = JSON.parse(localStorage.getItem("subUrl"));
    const unsub_url = JSON.parse(localStorage.getItem("unsubUrl"));
    const subStatus = localStorage.getItem("subStatus");
    console.log("Validity is::",validity,displayStatus,msisdn)
    if (unsub_btn_text || msg_text || sub_text || sub_url || unsub_url) {
      setUnsubObj({
        ...unsubObj,
        msg_txt: msg_text,
        unsub_btn_text: unsub_btn_text,
        usub_url: unsub_url,
      });
      setSubObj({ ...subObj, sub_btn_text: sub_text, sub_url: sub_url });
      setDisplayStatus(displayStatus);
      setMsisdn(msisdn);
      setValidity(validity);
      setUserStatus(subStatus);
    }
  }, []);

  const handleSubsribeClick = () => {
    console.log("Subscribe button clicked");
    console.log(screen.account, events.subcription_redirect);
    //logEvent for unsub redirection
    logSubEvent(
      {
        screen: "account_s",
        event: "sub_redirect",
      },
      {
        title: "sub_redirect",
        others: {
          date: new Date(),
        },
      }
    );
    navigate("/subs/packs");
  };
  const handleUnsubsribeClick = () => {
    console.log("Unsubscribe button clicked");
    setShowModel(true);
  };
  const handleYesClick = async () => {
    setLoading(true)
    logEvent(
      {
        screen: "account_s",
        event: "Unsub_api_request",
      },
      {
        title: "unsub",
        userId: uid ? uid : "",
        others: {
          date: new Date(),
        },
      }
    );
    console.log("Yes button clicked");
    const url = `${config.get("base")}${config.get("unsub")}`;
    const headers=
    {  ...getHeaders(),
    Language:language,
    camp : sessionStorage.getItem("campId"),
    rcid : sessionStorage.getItem("rcid")};

    await axios
      .post(url, { uid: uid }, {headers:headers})
      .then((result) => {
        console.log("Unsub api:::", result);
        setShowModal(true);
        setLoading(false)
        setMessage(result.data.message);
        
        if(result?.data?.status==="success")
          {
            // localStorage.removeItem("uid")
            // localStorage.removeItem("msisdn")
            localStorage.removeItem("subStatus")
          }
        logEvent(
          {
            screen: "account_s",
            event: "unsub_api_response",
          },
          {
            title: "unsub",
            userId: uid ? uid : "",
            others: {
              status: result?.data?.status,
              date: new Date(),
            },
          }
        );
      })
      .catch((err) => {
        console.log("error is:::", err);
      });
  };
  if (loading) return <Loader />;
  return (
    <>
      {unsubObj && subObj && (
        <>
          <Header />
          <div className="pt-28 m-auto  h-screen mx-2 ">
            <div className="w-full  ">
              <div className="w-full flex flex-row break-all fadeInOut card-shadow my-2 rounded-md px-4">
                <div className="w-1/2 text-start py-4 grey-theme-color">
                  {text?.numText?.[language]}
                </div>
                <div className="w-1/2 text-start mt-auto mb-auto italic">
                  {msisdn ? msisdn : "---"}
                </div>
              </div>
              <div className="w-full flex flex-row break-all fadeInOut card-shadow my-2 rounded-md px-4">
                <div className="w-1/2 text-start py-4 grey-theme-color">
                 {text.userStatusText?.[language]}
                </div>
                <div className="w-1/2 text-start mt-auto mb-auto italic  capitalize">
                  {displayStatus ? displayStatus : "---"}
                </div>
              </div>
              <div className="w-full flex flex-row break-all fadeInOut card-shadow my-2 rounded-md px-4">
                <div className="w-1/2 text-start py-4 grey-theme-color">
                  {text.validityText?.[language]}
                </div>
                <div className="w-1/2 text-start mt-auto mb-auto italic">
                  {validity ? validity : "---"}
                </div>
              </div>
              <div className="flex flex-col justify-center items-center mt-6">
                {userStatus !== "active" && (
                  <button
                    type="submit"
                    className="italic bg-green-400 w-3/4 p-2 rounded-md text-center font-bold "
                    onClick={handleSubsribeClick}
                  >
                    {text?.subscribeText?.[language]}
                  </button>
                )}
                {userStatus === "active" && (
                  <button
                    type="submit"
                    className="italic text-red-400 w-3/4 p-2 rounded-md text-center card-shadow font-bold"
                    onClick={handleUnsubsribeClick}
                  >
                    {text?.unsubBtnText?.[language]}
                  </button>
                )}
              </div>
            </div>
          </div>

          <ConfirmPopUp
            showModel={showModel}
            setShowModel={setShowModel}
            handleYesClick={handleYesClick}
          />
          {showModal && (
            <Alert message={message} handleOkClick={() => navigate("/home")} />
          )}
        </>
      )}
    </>
  );
};

export default Account;
